import React, { useState } from 'react';
import ModalWrapper from '../../components/elements/ModalWrapper';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import FormPointManagement from './FormPointManagement';

interface CreateMasterLevelProps {
  isVisible: boolean;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  listLevel: any;
  data: any;
  type: string;
}

const CreateMasterLevel: React.FC<CreateMasterLevelProps> = ({
  isVisible,
  onSubmit,
  onClose,
  listLevel,
  loading,
  data,
  type
}) => {
  const [modalDialog, setModalDialog] = useState({
    show: false,
    data: null
  });

  const handleSubmitData = (data: any) => {
    setModalDialog({
      show: true,
      data: data
    });
  };

  const handleConfirm = () => {
    setModalDialog({
      show: false,
      data: null
    });
    onSubmit(modalDialog.data);
  };

  return (
    <>
      <ModalWrapper
        title={`${type === 'edit' ? 'Update' : 'Create'} Point Management`}
        isVisible={isVisible}
        onClose={onClose}
      >
        <FormPointManagement
          onClose={onClose}
          loading={loading}
          listLevel={listLevel}
          handleSubmitData={handleSubmitData}
          type={type}
          data={data}
        />
      </ModalWrapper>

      <ModalConfirmation
        isVisible={modalDialog.show}
        type={type}
        onCancel={() => {
          setModalDialog({
            show: false,
            data: null
          });
        }}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default CreateMasterLevel;
